import React,{useEffect} from "react";
import { useParams } from "react-router-dom";
import { products, GandhidhamProducts, MundraProducts } from "../Data";
import NotFound from "./NotFound";
import Breadcrumb from "../Components/Breadcrumb";
import ProductIntro from "../Components/ProductIntro";
import Industries from "../Components/Industries";
import Cta from "../Components/Cta";
import ProductFeatures from "../Components/ProductFeatures";
import CustomCta from "../Components/CustomCta";
import ProductFaqs from "../Components/ProductFaqs";
import SchemaMarkup from "../Components/SchemaMarkup";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";
import createProductSchema from "../Schema/productSchema";
import createFaqSchema from "../Schema/faqSchema";

const Products=()=>{
const { slug } = useParams();

const product =
  products.find(item => item.slug === slug) ||
  GandhidhamProducts.find(item => item.slug === slug)||
  MundraProducts.find(item => item.slug === slug);

  useEffect(() => {
      if (!product) return;
      document.title = `${product.metaTitle}`;
      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
  
      if (metaDesc) {
        metaDesc.setAttribute("content", product.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://gurukrupawood.com/products/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      product.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      product.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://gurukrupawood.com/products/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://gurukrupawood.com/product.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     product.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    product.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://gurukrupawood.com/product.webp"
    );
  }

    }, [product, slug]);


  if (!product) {
    return <NotFound />;
  }

  const isGandhidhamProduct = GandhidhamProducts.some(
  item => item.slug === slug
);

  const isMundraProduct = MundraProducts.some(
  item => item.slug === slug
);

  const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: isGandhidhamProduct
      ? "Products in Gandhidham"
      : isMundraProduct
      ? "Products in Mundra"
      : "Products",

    url: isGandhidhamProduct
      ? "https://gurukrupawood.com/products/gandhidham"
      : isMundraProduct
      ? "https://gurukrupawood.com/products/mundra"
      : "https://gurukrupawood.com/products"
  },
  {
    name: product.title,
    url: `https://gurukrupawood.com/products/${product.slug}`
  }
]);

const productSchema = createProductSchema({
  name: product.title,
  description: product.metaDesc,
  url: `https://gurukrupawood.com/products/${product.slug}`,
});

const faqSchema = createFaqSchema({
  url: `https://gurukrupawood.com/products/${product.slug}`,
  faqs: product.faqs
});

    return(
        <>
         <React.Fragment key={slug}>

          <SchemaMarkup data={breadcrumbSchema} />
          <SchemaMarkup data={productSchema} />
          <SchemaMarkup data={faqSchema} />

       <Breadcrumb
  pageName={product.breadcrumbHeading || product.title}
  parentPage={
    isGandhidhamProduct
      ? "Products in Gandhidham"
      : isMundraProduct
      ? "Products in Mundra"
      : "Products"
  }
  bgImage={product.breadcrumbImg}
/>

        {/**INTRODUCTION SECTION */}
<ProductIntro
  title={product.introHeading || product.title}
  description={product.introDesc}
  brochure={product.brochureLink}
  images={product.images}
  features={product.qualities}
  slug={
    isGandhidhamProduct
      ? "/products/customised-packaging-solution-in-gandhidham"
      : isMundraProduct
      ? "/products/customised-packaging-solution-in-mundra"
      : "/products/customised-packaging"
  }
/>

        {/**FEATURES SECTION */}
        <ProductFeatures
  image={product.featureImage}
  features={product.features}
/>

        {/**INDUSTRIES SECTION */}
        <Industries 
        heading={product.industriesHeading}
        />
          <div className="industries-service-pg"></div>

        {/**CUSTOM CTA SECTION */}
       <CustomCta
  heading={product.ctaTitle}
  desc={product.ctaDesc}
  slug={
    isGandhidhamProduct
      ? "/products/customised-packaging-solution-in-gandhidham"
      : isMundraProduct
      ? "/products/customised-packaging-solution-in-mundra"
      : "/products/customised-packaging"
  }
/>

        {/**FAQS SECTION */}
        <ProductFaqs
  heading={product.faqsHeading}
  faqs={product.faqs}
/>


        {/**CTA SECTION */}
       <Cta
  heading={product.cta2Title}
  desc={product.cta2Desc}
  slug={
    isGandhidhamProduct
      ? "/products/customised-packaging-solution-in-gandhidham"
      : isMundraProduct
      ? "/products/customised-packaging-solution-in-mundra"
      : "/products/customised-packaging"
  }
/>

         </React.Fragment>
        </>
    )
}
export default Products;